import React, { useEffect } from 'react';
import { useUser } from 'state/auth';
import { trackAuthentication } from 'utils/analytics';

const Analytics: React.FC = () => {
  const { user } = useUser();
  useEffect(() => {
    if (!user?.id || !user?.company_id) {
      return;
    }
    trackAuthentication({
      userId: user?.id,
      companyId: user?.company_id,
    });
  }, [trackAuthentication, user?.company_id, user?.id]);

  return null;
};

export default Analytics;
